import { LightBulbIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';

interface HelpNoteProps {
  children: ReactNode;
}

export function HelpNote({ children }: HelpNoteProps) {
  return (
    <div className="flex gap-2.5 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
      <LightBulbIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <p className="leading-relaxed">{children}</p>
    </div>
  );
}
